<template>
    <div class="mt-6 bg-white rounded-md shadow sm:px-0">
        <div class="px-4 py-3 border-b border-gray-200 sm:px-6">
            <div class="flex flex-wrap items-center justify-between -ml-4 sm:flex-no-wrap">
                <div class="ml-4">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Invites</h3>
                </div>
            </div>
        </div>
        <!-- Loading state -->
        <div v-if="isLoading" class="w-full">
            <div class="flex flex-col space-x-4 animate-pulse">
                <div class="flex flex-col items-center w-full py-1 my-4 space-y-4">
                    <div v-for="i in [0, 1]" :key="i" class="flex flex-row w-full px-6 pb-2 border-b justify-evenly">
                        <div class="w-1/6 h-8 bg-gray-300 rounded"></div>
                        <div class="w-1/3 h-8 bg-gray-300 rounded"></div>
                        <div class="w-1/4 h-8 bg-gray-300 rounded-md"></div>
                    </div>
                    <div class="flex flex-row w-full px-6 justify-evenly">
                        <div class="w-1/6 h-8 bg-gray-300 rounded"></div>
                        <div class="w-1/3 h-8 bg-gray-300 rounded"></div>
                        <div class="w-1/4 h-8 bg-gray-300 rounded-md"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="flex flex-col">
            <div class="py-2 -my-2">
                <div class="inline-block min-w-full align-middle rounded-b-md">
                    <table class="min-w-full">
                        <thead>
                            <tr class="border-l border-r border-gray-100">
                                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    Token
                                </th>
                                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    Invite Link
                                </th>
                                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">Uses</th>
                                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                    Created On
                                </th>
                                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">Active</th>
                                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"></th>
                            </tr>
                        </thead>
                        <tbody class="bg-white">
                            <tr v-for="invite in invites" :key="invite.id">
                                <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                                    {{ invite.token }}
                                </td>
                                <td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-gray-200">
                                    <span class="px-1 py-2 border-2 border-transparent rounded-md bg-primary-100 hover:border-primary-300">{{ inviteLink(invite.token) }}</span>
                                </td>
                                <td class="px-6 py-4 font-medium text-gray-400 whitespace-no-wrap border-b border-gray-200">1</td>
                                <td class="relative px-6 py-4 text-sm font-normal leading-5 text-left whitespace-no-wrap border-b border-gray-200">
                                    <time :datetime="invite.inserted_at">
                                        {{
                                            $moment
                                                .utc(invite.inserted_at)
                                                .local()
                                                .format('MMMM D, YYYY')
                                        }}
                                    </time>
                                </td>
                                <td class="relative px-6 py-4 text-sm font-normal leading-5 text-left whitespace-no-wrap border-b border-gray-200">
                                    <span v-if="invite.active" class="inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full">
                                        Active
                                    </span>
                                    <span v-else class="inline-flex px-2 text-xs font-semibold leading-5 text-yellow-800 bg-yellow-100 rounded-full">
                                        Not active
                                    </span>
                                </td>
                                <td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-gray-200">
                                    <button v-if="invite.active" @click="changeStatus(invite)">
                                        <svg class="w-5 h-5 text-red-500 duration-150 transform fill-current hover:scale-125" viewBox="0 0 24 24">
                                            <path
                                                d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
                                            />
                                        </svg>
                                    </button>
                                    <button v-else @click="changeStatus(invite)">
                                        <svg class="w-5 h-5 duration-150 transform fill-current hover:rotate-180" viewBox="0 0 24 24">
                                            <path
                                                d="M21,11a1,1,0,0,0-1,1,8.05,8.05,0,1,1-2.22-5.5h-2.4a1,1,0,0,0,0,2h4.53a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4.77A10,10,0,1,0,22,12,1,1,0,0,0,21,11Z"
                                            />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/client';
export default {
    name: 'invites-table',
    props: {
        org: Object,
    },
    data() {
        return {
            isLoading: true,
            invites: [],
        };
    },
    mounted() {
        api.get(`/invites?org_id=${this.org.id}`).then(resp => {
            this.invites = resp.data.data;
            this.isLoading = false;
        });
    },
    methods: {
        inviteLink(token) {
            return process.env.VUE_APP_BASE_URL + 'invite/' + token;
        },
        changeStatus(invite) {
            api.put(`invites/${invite.id}`, { invite: { ...invite, active: !invite.active } })
                .then(resp => {
                    const item = this.invites.find(i => invite.id === i.id);
                    Object.assign(item, resp.data.data);
                })
                .catch(err => {});
        },
    },
};
</script>
